import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import RainCheck from "pages/secure/facility/order/RainCheck";
import * as UIActions from "redux/actions/ui";

const mapDispatchToProps = (dispatch: any) => {
  return {
    uiActions: bindActionCreators(
      {
        ...UIActions,
      },
      dispatch,
    ),
  };
};

const mapStateToProps = (state: any) => {
  const { uiStore } = state;
  return {
    uiStore: { ...uiStore },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RainCheck);
